import { getMobileV2RedirectUrl } from '../components/utils/RedirectUrl';
import { normalizeTzParam } from './timezone';

export const DIRECT_LOGIN_PROGRESS_KEY = 'directLoginInProgress';
export const LOGIN_BODY_COLOR = '#1a1f36';
export const MOBILE_DIRECT_LOGIN_BREAKPOINT = 960;

export function hasDirectLoginTokenInUrl() {
  try {
    return new URLSearchParams(window.location.search).has('token');
  } catch {
    return false;
  }
}

export function isMobileDirectLoginViewport() {
  try {
    return typeof window !== 'undefined' && window.innerWidth <= MOBILE_DIRECT_LOGIN_BREAKPOINT;
  } catch {
    return false;
  }
}

export function applyLoginShellStyles() {
  document.documentElement.style.backgroundColor = LOGIN_BODY_COLOR;
  document.body.style.backgroundColor = LOGIN_BODY_COLOR;
  document.body.style.minHeight = '100vh';
  document.body.style.display = 'block';
}

/**
 * Runs before React mounts. Returns true if a full-page redirect was triggered.
 *
 * On mobile, hand off to app-suite BEFORE Login mounts — otherwise Login consumes
 * ?token= (AuthenticateUser clears direct_login_token) and the app redirect gets an expired token.
 */
export function bootstrapDirectLoginShell() {
  if (!hasDirectLoginTokenInUrl()) {
    return false;
  }

  try {
    const params = new URLSearchParams(window.location.search);
    const tzParam = params.get('tz') || params.get('timezone');
    if (tzParam) {
      const normalized = normalizeTzParam(tzParam);
      if (normalized) {
        localStorage.setItem('utc_time', normalized);
      }
    }
  } catch (_) {}

  applyLoginShellStyles();

  if (isMobileDirectLoginViewport()) {
    const v2Url = getMobileV2RedirectUrl();
    if (v2Url) {
      window.location.replace(v2Url);
      return true;
    }
  }

  if (window.location.pathname !== '/') {
    window.location.replace(`/${window.location.search}${window.location.hash}`);
    return true;
  }

  sessionStorage.setItem(DIRECT_LOGIN_PROGRESS_KEY, '1');
  return false;
}
